import toast from 'react-hot-toast';
import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { LinkedFastagItem } from '../types/LinkedFastag';
import { StatusPopupData } from '../types/StatusPopup';
import { FastagStatus, StatusMapping } from '../constants';
import { formatStatusPopupData } from '../utils';

function serialize(list: any[]) {
  const linkedFastag: LinkedFastagItem[] = [];
  list.forEach((el) => {
    let statusPopupData: StatusPopupData | null = null;
    if (el?.vehicle_number) {
      let status: FastagStatus = FastagStatus.Active;
      if (el?.fastag_recharge_status?.status) {
        status =
          StatusMapping[el?.fastag_recharge_status?.my_fastag_active_status?.toUpperCase()];
      }

      if (status !== FastagStatus.Active) {
        statusPopupData = formatStatusPopupData(el?.fastag_recharge_status);
      }

      linkedFastag.push({
        id: el.id,
        bank: {
          id: el.bank_id,
          name: el.bank_name,
          logo: el.bank_icon_url,
        },
        owner: {
          name: el.owner_name,
        },
        status,
        statusPopupData,
        vehicle: {
          license: el.vehicle_number,
          brandLogo: el.brand_icon,
          model: el.model,
          brand: el?.brand ?? '',
        },
        billerId: el.biller_id,
        showBalance:
          el.show_balance && el.fastag_balance && el.fastag_balance !== '',
        balance: el.fastag_balance,
        minLimit: el?.extra_info?.min_amount ?? null,
        maxLimit: el?.extra_info?.max_amount ?? null,
        isChassis: el?.is_chasis,
      });
    }
  });
  return linkedFastag;
}

type ResultTypes = {
  response?: LinkedFastagItem[];
  error?: any;
};

export const fetchLinkedFastags = (): Promise<ResultTypes> =>
  new Promise((resolve) => {
    (async function callLinkedFastagApi() {
      const url = `${apiConfig(
        'fastagIssuance'
      )}/fastag-recharge/tag/v2/my-fastag/vehicle-listing`;
      const { response, error }: any = await getMethod({
        endPoint: url,
        params: { page: 1, limit: 10 },
      });
      if (response) {
        if (response?.data?.result) {
          resolve({ response: serialize(response.data.result) });
        } else resolve({ error: {} });
      }
      if (error) {
        resolve({ error });
        toast.error('Unable to fastags');
      }
    })();
  });
